import { button, paper } from '@brig/theme/styles';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { NotFound } from './NotFound.tsx';
import * as styles from './NotFound.css.ts';

export function ErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFound />;
  return (
    <main className={styles.sea}>
      <section className={`${paper} ${styles.sheet}`} role="alert">
        <h1>{t('error.title')}</h1>
        <p>{t('error.body')}</p>
        <button
          type="button"
          className={button({ tone: 'seal' })}
          onClick={() => {
            window.location.reload();
          }}
        >
          {t('error.reload')}
        </button>
      </section>
    </main>
  );
}
